
import { defineComponent, onMounted, ref } from "vue";
import "bootstrap/dist/js/bootstrap.min";
import { useStore } from "vuex";

export default defineComponent({
  name: "admin-navbar-header-component",
  setup() {
    const store = useStore();

    const account = ref("");
    const subscriberType = ref(0);

    onMounted(() => {
      if (store.getters.isUserAuthenticated) {
        account.value = store.getters.currentUser.account;
        subscriberType.value = store.getters.currentUser.subscriberType;
      }
    });

    return {
      account,
      subscriberType
    }
  }
});
